// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-contacts-js": () => import("./../../../src/pages/contacts.js" /* webpackChunkName: "component---src-pages-contacts-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-lof-fa-s-22-26-js": () => import("./../../../src/pages/LofFaS22-26.js" /* webpackChunkName: "component---src-pages-lof-fa-s-22-26-js" */),
  "component---src-pages-templates-with-graphql-js": () => import("./../../../src/pages/templates/with-graphql.js" /* webpackChunkName: "component---src-pages-templates-with-graphql-js" */),
  "component---src-pages-using-typescript-tsx": () => import("./../../../src/pages/using-typescript.tsx" /* webpackChunkName: "component---src-pages-using-typescript-tsx" */)
}

